import { useEffect, useState } from 'react';
import { Share, X } from 'lucide-react';
import { isIOS, isStandalone } from '@/lib/ios';
import { InstallSheet } from '@/features/settings/Settings';

type BIPEvent = Event & { prompt: () => Promise<void>; userChoice: Promise<{ outcome: string }> };
declare global { interface Window { _installPrompt: BIPEvent | null } }

/* Android/desktop get the native prompt (captured early in index.html).
   iOS has no install API, so it gets a Share → Add to Home Screen guide —
   the step neither sibling app had, and the one iOS push depends on. */
export function InstallBanner() {
  const [dismissed, setDismissed] = useState(() => { try { return localStorage.getItem('ftu_install_dismissed') === '1'; } catch { return false; } });
  const [prompt, setPrompt] = useState<BIPEvent | null>(() => window._installPrompt);
  const [help, setHelp] = useState(false);
  useEffect(() => {
    const on = () => setPrompt(window._installPrompt);
    window.addEventListener('installpromptready', on);
    return () => window.removeEventListener('installpromptready', on);
  }, []);
  if (dismissed || isStandalone() || (!isIOS() && !prompt)) return null;
  const dismiss = () => { setDismissed(true); try { localStorage.setItem('ftu_install_dismissed', '1'); } catch {} };
  return (
    <div className="px-4 pb-4">
      <div className="flex items-center gap-3 rounded-[20px] bg-surface p-3">
        <img src="/icons/icon-192.png" alt="" className="h-11 w-11 rounded-xl" />
        <div className="min-w-0 flex-1">
          <div className="text-[15px] font-semibold">Install the app</div>
          <div className="text-[13px] text-muted">Full screen, offline, with adhan notifications.</div>
        </div>
        <button type="button" className="press rounded-full bg-accent px-3.5 py-1.5 text-[14px] font-semibold text-accent-ink"
          onClick={async () => { if (prompt) { await prompt.prompt(); setPrompt(null); } else setHelp(true); }}>
          {isIOS() ? <span className="flex items-center gap-1"><Share size={14} /> How</span> : 'Install'}
        </button>
        <button type="button" aria-label="Dismiss" className="p-1 text-faint" onClick={dismiss}><X size={16} /></button>
      </div>
      <InstallSheet open={help} onClose={() => setHelp(false)} />
    </div>
  );
}
